<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-yellow-50 p-3 border-1 border-yellow-100 border-round-lg">
            <i class="pi pi-calendar text-yellow-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
         <button
            *ngFor="let tab of visibleTabs()"
            type="button"
            class="tab-nav__item"
            [class.tab-nav__item--active]="activeTab() === tab.value"
            (click)="activeTab.set(tab.value)"
         >
            <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
            <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
            <span>{{ tab.label }}</span>
         </button>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 overflow-auto h-full pb-4">
      <div class="flex flex-column gap-4">
         <!-- Day of Week Card -->
         <div class="surface-card p-4 border-1 border-round-xl border-cyan-100 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
               <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-calendar-times text-cyan-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.PREVIEW.DAY_OF_WEEK_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-cyan-800">
                     {{
                        dayOfWeek() === 'MONDAY'
                           ? ('DATA.COMMON.DAYS_OF_WEEK.MONDAY' | translate)
                           : dayOfWeek() === 'TUESDAY'
                             ? ('DATA.COMMON.DAYS_OF_WEEK.TUESDAY' | translate)
                             : dayOfWeek() === 'WEDNESDAY'
                               ? ('DATA.COMMON.DAYS_OF_WEEK.WEDNESDAY' | translate)
                               : dayOfWeek() === 'THURSDAY'
                                 ? ('DATA.COMMON.DAYS_OF_WEEK.THURSDAY' | translate)
                                 : dayOfWeek() === 'FRIDAY'
                                   ? ('DATA.COMMON.DAYS_OF_WEEK.FRIDAY' | translate)
                                   : dayOfWeek() === 'SATURDAY'
                                     ? ('DATA.COMMON.DAYS_OF_WEEK.SATURDAY' | translate)
                                     : dayOfWeek() === 'SUNDAY'
                                       ? ('DATA.COMMON.DAYS_OF_WEEK.SUNDAY' | translate)
                                       : '-'
                     }}
                  </span>
               </div>
            </div>
         </div>

          <!-- Part of Day Card -->
          <div class="surface-card p-4 border-1 border-round-xl border-purple-100 flex flex-column gap-3">
              <div class="flex align-items-center gap-3">
                  <div class="bg-purple-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                      <i class="pi pi-sun text-purple-700 text-lg"></i>
                  </div>
                  <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                          'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.PREVIEW.TIME_OF_DAY_LABEL' | translate
                      }}</span>
                      <span class="text-xl font-semibold text-purple-800">
                     {{
                              partDay() === 'MORNING'
                                  ? ('DATA.COMMON.TIME_OF_WEEK.MORNING' | translate)
                                  : partDay() === 'EVENING'
                                      ? ('DATA.COMMON.TIME_OF_WEEK.EVENING' | translate)
                                      : partDay() === 'FULL_DAY'
                                          ? ('DATA.COMMON.TIME_OF_WEEK.FULL_DAY' | translate)
                                          : '-'
                          }}
                  </span>
                  </div>
              </div>
          </div>

         <p-messages severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-calendar p-1"></span>
                  <span [innerHTML]="getSummaryMessage()"></span>
               </div>
            </ng-template>
         </p-messages>

         <p-divider class="w-full"></p-divider>
         <!-- Regional Config Info -->
          <app-regional-config-info
              [collectorIds]="campaignSelected()?.collectorIds || []"
              [campaignType]="campaignSelected()?.type">
          </app-regional-config-info>

         <div *ngIf="errors().length" class="flex flex-column gap-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 overflow-auto h-full pb-4">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.DAY_OF_WEEK_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.DAY_OF_WEEK_HELP' | translate
               }}</span>
            </div>

            <p-dropdown
               [options]="dayOfWeekOptions()"
               [ngModel]="dayOfWeek()"
               (ngModelChange)="onDayOfWeekChange($event)"
               optionLabel="label"
               optionValue="value"
               styleClass="w-full"
               class="w-full"
               [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.DAY_OF_WEEK_PLACEHOLDER' | translate"
            ></p-dropdown>
         </div>

         <p-divider class="w-full"></p-divider>

          <div class="flex flex-column gap-3">
              <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                       'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.PART_DAY_LABEL' | translate
                   }}</span>
                  <span class="text-sm text-500">{{
                          'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.PART_DAY_HELP' | translate
                      }}</span>
              </div>

              <p-dropdown
                  [options]="partDayOptions()"
                  [ngModel]="partDay()"
                  (ngModelChange)="onPartDayChange($event)"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="w-full"
                  class="w-full"
                  [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAY_OF_WEEK.CONFIG.PART_DAY_PLACEHOLDER' | translate"
              ></p-dropdown>
          </div>

          <p-divider></p-divider>


          <!-- Regional Config Info -->
          <app-regional-config-info
              [collectorIds]="campaignSelected()?.collectorIds || []"
              [campaignType]="campaignSelected()?.type">
          </app-regional-config-info>

         <div *ngIf="errors().length" class="flex flex-column gap-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>
</div>
